/* tslint:disable */
/* eslint-disable */
/**
 * CMA API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PropertyImageResponseDto
 */
export interface PropertyImageResponseDto {
    /**
     * 
     * @type {string}
     * @memberof PropertyImageResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PropertyImageResponseDto
     */
    url: string;
    /**
     * 
     * @type {string}
     * @memberof PropertyImageResponseDto
     */
    cdnUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof PropertyImageResponseDto
     */
    caption?: string;
}

/**
 * Check if a given object implements the PropertyImageResponseDto interface.
 */
export function instanceOfPropertyImageResponseDto(value: object): value is PropertyImageResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('url' in value) || value['url'] === undefined) return false;
    return true;
}

export function PropertyImageResponseDtoFromJSON(json: any): PropertyImageResponseDto {
    return PropertyImageResponseDtoFromJSONTyped(json, false);
}

export function PropertyImageResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PropertyImageResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'url': json['url'],
        'cdnUrl': json['cdnUrl'] == null ? undefined : json['cdnUrl'],
        'caption': json['caption'] == null ? undefined : json['caption'],
    };
}

export function PropertyImageResponseDtoToJSON(json: any): PropertyImageResponseDto {
    return PropertyImageResponseDtoToJSONTyped(json, false);
}

export function PropertyImageResponseDtoToJSONTyped(value?: PropertyImageResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'url': value['url'],
        'cdnUrl': value['cdnUrl'],
        'caption': value['caption'],
    };
}

